import * as React from "react";
import Loading from ".";
var retryLoading = function () { };
var RBLoading = (React.createElement(Loading, { isLoading: true, pastDelay: true, error: undefined, timedOut: false, retry: retryLoading }));
export default RBLoading;
